



































































import { Component, Vue, Prop } from "vue-property-decorator";
import speakers from "@/models/speakers";

@Component
export default class SpeakerProfile extends Vue {
  private speaker: any;
  private defaults: any;
  private speakersList: any;

  constructor() {
    super();
    this.speakersList = speakers;
    this.defaults = {
      bgBanner:
        "https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=750&q=80"
    };
  }

  private created() {
    this.speaker = this.speakersList.filter(
      (speaker: any) => speaker.name === this.$router.currentRoute.query.name
    )[0];
  }
}
